var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0349 0.141556C26.1033 0.515388 21.7076 1.76578 18.3044 3.48023C14.7853 5.25914 11.0986 8.06929 8.57201 10.9052C3.62201 16.474 0.811857 22.9064 0.128654 30.2283C-0.399862 35.9775 0.837638 42.4615 3.48022 47.6951C5.25912 51.2142 8.06928 54.9009 10.9052 57.4275C16.474 62.3775 22.9064 65.1877 30.2283 65.8709C35.9775 66.3994 42.4615 65.1619 47.6951 62.5193C51.2142 60.7404 54.9009 57.9302 57.4275 55.0943C62.3775 49.5255 65.1876 43.0931 65.8708 35.7712C66.3994 30.022 65.1619 23.538 62.5193 18.3045C60.7404 14.7853 57.9302 11.0986 55.0943 8.57203C49.5255 3.62203 43.0931 0.811874 35.7712 0.12867C34.1599 -0.0131302 31.6462 -0.0131302 30.0349 0.141556ZM27.547 22.0685L32.9997 27.5212L38.4783 22.0427L43.9568 16.5642L46.6896 19.3099L49.4353 22.0427L43.9568 27.5212L38.4783 32.9998L43.9568 38.4783L49.4353 43.9568L46.6896 46.6896L43.9568 49.4353L38.4783 43.9568L32.9997 38.4783L27.5212 43.9568L22.0427 49.4353L19.3099 46.6896L16.5642 43.9568L22.0427 38.4783L27.5212 32.9998L22.0427 27.5212L16.5642 22.0427L19.2712 19.3357C20.7537 17.8533 22.004 16.6287 22.0427 16.6287C22.0814 16.6287 24.5564 19.0779 27.547 22.0685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b27d609a49c67847013efd20bb9a9b39.svg";
export { ForwardRef as ReactComponent };